import {
  resolveReceituarioProfile,
  stampReceituarioProfile,
} from "../helpers/receituarioProfile";
import {
  claimSncrNumeroOrNext,
  peekNextSncrNumero,
} from "./sncrNumeracaoBasicService";

type Refs = {
  practitionerReference?: string;
};

export function clearSncrPreviewFields(item: any): any {
  if (!item || item?.sncrClaimed) return item;
  return {
    ...item,
    sncrNumero: undefined,
    sncrBasicId: undefined,
    sncrPreview: undefined,
  };
}

export async function ensureSncrPreviewForIntervention(
  item: any,
  refs: Refs,
  excludeNumeros: string[] = [],
): Promise<any> {
  const stamped = stampReceituarioProfile(item);
  const profile = resolveReceituarioProfile(stamped);

  if (!profile.consomeSncr || !profile.sncrTipo) {
    return clearSncrPreviewFields(stamped);
  }

  if (stamped?.sncrClaimed && stamped?.sncrNumero && stamped?.sncrBasicId) {
    return stamped;
  }

  const excluded = new Set(
    (excludeNumeros ?? []).filter((n) => !!n && n !== stamped?.sncrNumero),
  );

  if (
    stamped?.sncrTipo === profile.sncrTipo &&
    stamped?.sncrNumero &&
    stamped?.sncrBasicId &&
    !stamped?.sncrClaimed &&
    !excluded.has(stamped.sncrNumero)
  ) {
    return {
      ...stamped,
      sncrTipo: profile.sncrTipo,
      sncrPreview: true,
    };
  }

  const peeked = await peekNextSncrNumero({
    tipo: profile.sncrTipo,
    practitionerReference: refs.practitionerReference,
    excludeNumeros: [...excluded],
  });

  return {
    ...stamped,
    sncrNumero: peeked.numero,
    sncrBasicId: peeked.basicId,
    sncrTipo: peeked.tipo,
    sncrPreview: true,
    sncrClaimed: false,
  };
}

export async function ensureSncrNumeroForIntervention(
  item: any,
  refs: Refs,
  excludeNumeros: string[] = [],
): Promise<any> {
  const stamped = stampReceituarioProfile(item);
  const profile = resolveReceituarioProfile(stamped);

  if (!profile.consomeSncr || !profile.sncrTipo) {
    return clearSncrPreviewFields(stamped);
  }

  if (stamped?.sncrClaimed && stamped?.sncrNumero && stamped?.sncrBasicId) {
    return stamped;
  }

  const claimed = await claimSncrNumeroOrNext({
    tipo: profile.sncrTipo,
    basicId: stamped?.sncrBasicId,
    numero: stamped?.sncrNumero,
    practitionerReference: refs.practitionerReference,
    excludeNumeros,
  });

  return {
    ...stamped,
    sncrNumero: claimed.numero,
    sncrBasicId: claimed.basicId,
    sncrTipo: claimed.tipo,
    sncrPreview: false,
    sncrClaimed: true,
  };
}
